import { useCallback, useEffect, useRef, useState } from 'react'
import { DataLayoutViews } from './DataLayout'

const baseRules = {
  captureImageRule: view => view !== DataLayoutViews.CHART,
  downloadFileRule: view => view !== DataLayoutViews.TABLE
}

/**
 * The DataLayout's custom hook.
 */
const useDataLayout = ({
  customRules = baseRules,
  dependencies = [],
  captureImageCallback = () => undefined,
  changeViewCallback = () => undefined,
  downloadFileCallback = () => undefined
} = {}) => {
  const ref = useRef({})
  const rulesRef = useRef({ ...baseRules, ...customRules })
  const [counter, setCounter] = useState(0)
  const [disableCaptureImage, setDisableCaptureImage] = useState(false)
  const [disableDownloadFile, setDisableDownloadFile] = useState(false)
  const handleCaptureImage = useCallback(event => captureImageCallback(event), dependencies)
  const handleChangeCounter = useCallback(() => setCounter(currentValue => currentValue + 1), [])
  const handleChangeView = useCallback(updatedView => {
    setDisableCaptureImage(rulesRef.current.captureImageRule(updatedView))
    setDisableDownloadFile(rulesRef.current.downloadFileRule(updatedView))
    changeViewCallback(updatedView)
  }, dependencies)
  const handleDownloadFile = useCallback(event => downloadFileCallback(event), dependencies)

  useEffect(() => {
    setDisableCaptureImage(rulesRef.current.captureImageRule(ref.current?.view))
    setDisableDownloadFile(rulesRef.current.downloadFileRule(ref.current?.view))
  }, [counter].concat(dependencies))

  return {
    disableCaptureImage,
    disableDownloadFile,
    ref,
    onCaptureImage: handleCaptureImage,
    onChangeView: handleChangeView,
    onDownloadFile: handleDownloadFile,
    update: handleChangeCounter
  }
}

export default useDataLayout
